import AssessmentIcon from "@mui/icons-material/Assessment";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import Box from "@mui/material/Box";

import { ToggleButton } from "@/Components/v2/atoms/Button";
import { ToggleButtonGroup } from "@/Components/v2/molecule/ButtonGroup/";

import { MROIChartType } from "../../../constants/types";
import { useMROIStore } from "../../../store/useMROIStore";

const options = [
  {
    value: MROIChartType.BUBBLE,
    icon: <BubbleChartIcon />,
  },
  {
    value: MROIChartType.COLUMN,
    icon: <AssessmentIcon />,
  },
];

const ChannelEffectivenessViewToggle = () => {
  const mroiView = useMROIStore((state) => state.chart.channelEffectiveness.chartType);
  const { setChartType } = useMROIStore();

  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: MROIChartType) => {
    setChartType(newValue);
  };

  return (
    <ToggleButtonGroup value={mroiView} exclusive sx={{ width: "280px" }}>
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value} onChange={handleChange}>
          {option.icon}
          <Box component="span" ml={1}>
            {option.value}
          </Box>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ChannelEffectivenessViewToggle;
